import { FC, ReactNode, Suspense, SuspenseProps, useMemo } from 'react'

interface BaseSuspenseProps extends SuspenseProps {
  children?: ReactNode
  loading?: boolean
}

const BaseSuspense: FC<BaseSuspenseProps> = ({ loading = true, fallback: _fallback, children }) => {
  const fallback = useMemo(() => _fallback, [])

  return loading ? <>{fallback}</> : <Suspense fallback={fallback}>{children}</Suspense>
}

export default BaseSuspense
